import React, { Component } from "react";
import { graphql } from "react-apollo";
import styled from "styled-components";
import { observer } from "mobx-react";
import { CaseHistoryStore } from "Store";
import HeaderView from "module-case-management/content-panel/header/HeaderView";
import MessageList from "module-case-management/content-panel/message-list/MessageListWithStoreQuery";
import EmptyPanel from "module-case-management/content-panel/EmptyPanel";

// this component is responsible for showing content panel
export default observer(
  class ContentPanel extends Component {
    render() {
      const { selectedCase, showInfoPanel, showCloseNotes } = CaseHistoryStore;
      if (selectedCase) {
        // console.log("SELECTED CASE", selectedCase);
        // if user selected case, show content
        const caseId = selectedCase.id;
        const customer = selectedCase.customerChannelHandler;
        const name = customer.name;
        const image = customer.displayPicture;
        const channel = selectedCase.channel.name;
        const channelName = selectedCase.channelHandler.name;
        const notes =
          selectedCase.noteClose == null
            ? "Note is empty"
            : selectedCase.noteClose.content;

        return (
          <Content>
            <HeaderView
              name={name}
              image={image}
              channel={channel}
              channelName={channelName}
              showInfo={showInfoPanel}
              notes={notes}
              showCloseNotes={showCloseNotes}
              onOpenInfoPanel={this.onOpenInfoPanel}
              store={CaseHistoryStore}
            />
            <MessageList
              key={"MessageList-" + caseId}
              case={{ id: caseId }}
              store={CaseHistoryStore}
            />
          </Content>
        );
      } else {
        // if no selected case, show empty screen
        return (
          <Content>
            <EmptyPanel />
          </Content>
        );
      }
    }

    onOpenInfoPanel = () => {
      CaseHistoryStore.showInfoPanel = true;
    };
  }
);

const Content = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
`;



// WEBPACK FOOTER //
// ./src/module-case-history/ContentPanelWithStore.js